import { ReactComponent as ChevronUp } from "../../assets/icons/chevron_up_black.svg";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron_down_black.svg";
import constraintStyles from "../../styles/constraint.module.css";

const ConstraintListItemTitle = ({
  title,
  subtitle,
  isOpen,
  onToggle,
}: {
  title: string;
  subtitle?: string;
  isOpen: boolean;
  onToggle: () => void;
}) => {
  return (
    <button
      className={constraintStyles.constraintListHeaderRow}
      onClick={onToggle}
      aria-expanded={isOpen}
    >
      {isOpen ? (
        <ChevronUp width={24} height={24} />
      ) : (
        <ChevronDown width={24} height={24} />
      )}
      <h3>{title}</h3>
      {subtitle && (
        <span style={{ color: "var(--col-text-secondary)" }}>{subtitle}</span>
      )}
    </button>
  );
};

export default ConstraintListItemTitle;
